import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.854 10.147a.5003.5003 0 0 0-.707 0L15 12.293V9.5C15 7.21 13.79 6 11.5 6h-8c-.276 0-.5.222-.5.5 0 .276.224.5.5.5h8c1.729 0 2.5.771 2.5 2.5v2.793l-2.146-2.146a.5003.5003 0 0 0-.707 0 .4985.4985 0 0 0 0 .707l3 3c.195.195.512.195.707 0l3-3a.5003.5003 0 0 0 0-.707z',
  ],
  height: 20,
  width: 20,
});
